import Dashboard from './Dashboard';
import DashboardDetailed from './DashboardDetailed';
import DashboardSimplified from './DashboardSimplified';

export default {
    Dashboard,
    DashboardDetailed,
    DashboardSimplified,
};
